(function () {
  const rules = window.__moq_rules || [];
  if (rules.length === 0) return;

  const productMinCache = {};
  let deletingItem = false;

  // ─── MARK DELETE INTENT ─────────────────────────────────────
  // Watch for clicks on trash/remove buttons in cart drawer
  document.addEventListener('click', (e) => {
    const isDeleteBtn = e.target.closest(
      '[data-cart-remove], .cart-remove-button, button[aria-label*="Remove"], button[aria-label*="remove"], button[aria-label*="Delete"], button[aria-label*="delete"], .cart-item__remove, [href*="/cart/change"][data-quantity="0"]'
    );
    if (isDeleteBtn) {
      deletingItem = true;
      // Reset after a short delay (enough for the fetch to fire)
      setTimeout(() => { deletingItem = false; }, 500);
    }
  }, true);

  // ─── CACHE HELPER ───────────────────────────────────────────
  function getMinForHandle(handle) {
    if (productMinCache[handle] !== undefined) {
      return Promise.resolve(productMinCache[handle]);
    }
    return fetch(`/products/${handle}.js`)
      .then((r) => r.json())
      .then((product) => {
        const tags = (product.tags || []).map((t) =>
          t.toLowerCase().replace(/\s+/g, '-')
        );
        const match = rules.find((rule) => tags.includes(rule.handle));
        const min = match ? match.min : 1;
        productMinCache[handle] = min;
        return min;
      })
      .catch(() => 1);
  }

  function getItemFromCart(cart, body) {
    if (body.id) return cart.items.find((i) => i.key === body.id || i.variant_id == body.id);
    if (body.line) return cart.items[body.line - 1];
    return null;
  }

  // ─── INTERCEPT fetch() ───────────────────────────────────────
  const originalFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input?.url;

    if (url && (url.includes('/cart/change') || url.includes('/cart/update'))) {
      let body;
      try { body = JSON.parse(init?.body); } catch (e) {
        return originalFetch.apply(this, arguments);
      }

      // Always allow deletes (quantity 0) through
      if (body.quantity === 0 || deletingItem) {
        return originalFetch.apply(this, [input, init]);
      }

      return originalFetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => {
          const item = getItemFromCart(cart, body);
          if (!item) return originalFetch.apply(this, [input, init]);

          return getMinForHandle(item.handle).then((min) => {
            if (min > 1 && body.quantity !== undefined && body.quantity < min) {
              body.quantity = min;
              init = { ...init, body: JSON.stringify(body) };
            }
            return originalFetch.apply(this, [input, init]);
          });
        })
        .catch(() => originalFetch.apply(this, [input, init]));
    }

    return originalFetch.apply(this, arguments);
  };

  // ─── INTERCEPT XMLHttpRequest ────────────────────────────────
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._url = url;
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    const url = this._url || '';
    if (url.includes('/cart/change') || url.includes('/cart/update')) {
      try {
        const data = JSON.parse(body);
        const xhr = this;

        // Always allow deletes through
        if (data.quantity === 0 || deletingItem) {
          return originalSend.apply(xhr, [body]);
        }

        originalFetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => {
            const item = getItemFromCart(cart, data);
            if (!item) return originalSend.apply(xhr, [body]);

            return getMinForHandle(item.handle).then((min) => {
              if (min > 1 && data.quantity !== undefined && data.quantity < min) {
                data.quantity = min;
              }
              return originalSend.apply(xhr, [JSON.stringify(data)]);
            });
          })
          .catch(() => originalSend.apply(xhr, [body]));
        return;
      } catch (e) {}
    }
    return originalSend.apply(this, arguments);
  };

  // ─── PRODUCT PAGE INPUT ENFORCEMENT ─────────────────────────
  if (window.location.pathname.includes('/products/')) {
    fetch(window.location.pathname + '.js')
      .then((r) => r.json())
      .then((product) => {
        const tags = (product.tags || []).map((t) =>
          t.toLowerCase().replace(/\s+/g, '-')
        );
        const match = rules.find((rule) => tags.includes(rule.handle));
        if (!match) return;

        productMinCache[product.handle] = match.min;

        const apply = () => enforceOnInput(
          document.querySelector('input[name="quantity"]'), match.min
        );
        apply();
        new MutationObserver(apply).observe(document.body, {
          childList: true, subtree: true
        });
      });
  }

  // ─── SHARED INPUT ENFORCEMENT ────────────────────────────────
  function enforceOnInput(input, min) {
    if (!input) return;
    input.setAttribute('min', min);
    if (parseInt(input.value) < min || isNaN(parseInt(input.value))) {
      input.value = min;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (input.dataset.moqListenerAdded) return;
    input.dataset.moqListenerAdded = 'true';
    input.addEventListener('change', () => {
      if (parseInt(input.value) < min) {
        input.value = min;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    input.addEventListener('blur', () => {
      if (parseInt(input.value) < min || isNaN(parseInt(input.value))) {
        input.value = min;
      }
    });
  }
})();